<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="section__content center login">
          <form v-on:submit.prevent="login">
            <h1 class="std__subtile">{{$t("login_title")}}</h1>
            <h2 class="std__subtile md">
              {{$t("confirmation")}}
            </h2>
            <div class="mobiForElm">
              <input
                type="tel"
                class="mobiForElm__input"
                v-model="msisdn"
                maxlength="13"
                placeholder
              />
            </div>
            <div class="btnContainer">
              <button type="submit" class="mobiBtn">{{$t("submit")}}</button>
            </div>
            <div
              v-if="showStatusAlert"
              class="alert alert-danger col-md-3"
              role="alert"
            >
              <span v-if="lang_f2w === 'english'">{{ status }}</span>
              <span v-if="lang_f2w !== 'english'">{{ statusTran }}</span>
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
            <div
              v-if="showMsisdnAlert"
              class="alert alert-danger col-md-5"
              role="alert"
            >
              {{$t("valid_number")}}
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import fun2win from "../../../router/fun2win";
import country_list from "../../../locales/country_list.json";
import EventBus from "../../EventBus.vue";
import { mapActions, mapGetters } from "vuex";

const proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

export default {
  data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  computed: mapGetters(["lang_f2w", "gcid_f2w", "country_f2w"]),
  methods: {
    close(){
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login() {
      let regex = /^\d{9,}$/;
      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          let gcid = "";
          if(this.gcid_f2w != ""){
            gcid = this.gcid_f2w;
          }else{
            gcid = "264";
          }
          
          let data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          const login = {
            url: `${proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=${data.msisdn}&gcid=${data.gcid}&verbose=${data.verbose}`),
            method: "POST"
          };
          this.$axios(login)
            .then(res => {
              var response = JSON.parse(res.data.contents);
              if (response.status == "active") {
                localStorage.setItem("userTokenID_f2w", response.token);
                this.msisdn = "";
                // this.emitMethod();
                this.login_f2w("loggedin");
                fun2win.push({ name: "Home" }).catch(err => {});
                location.reload();
              } else if (response.status == "inactive") {
                this.showStatusAlert = true;
                this.showMsisdnAlert = false;
                let status = response.status.replace( response.status.toUpperCase());
                this.status = status;

                for (let [key, value] of Object.entries(country_list)) {
                  if(this.country_f2w == key){
                    let status_lang = require(`../../../locales/fun2win/${value.language}.json`);
                    this.statusTran = status_lang.status;
                  }
                }
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      }
    },
    ...mapActions(["login_f2w"])
    // emitMethod() {

    // }
  }
};
</script>

<style lang="scss" scoped>
.section__content.login {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}

.alert {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/fun2win/Login.vue